import React from "react";
import SiteDetailPage from "@/components/sites/SiteDetailPage";

const CarmausineRecuperation = () => {
  const services = [
    "Collecte d'huiles minérales usagées",
    "Collecte d'huiles alimentaires usagées", 
    "Location de bennes",
    "Collecte de déchets",
    "Recyclage et valorisation",
    "Tri sélectif",
    "Recyclage de métaux",
    "Négoce de métaux"
  ];

  return (
    <SiteDetailPage
      title="Carmausine de Récupération - Recyclage Huiles et Métaux Carmaux (81400)"
      description="Carmausine de Récupération à Carmaux - Spécialiste de la collecte d'huiles usagées, recyclage métaux et location de bennes dans le Tarn. Services ICPE agréés."
      proximityInfo="Située aux confins du Tarn et de l'Aveyron, Carmausine de récupération privilégie le travail de proximité avec les acteurs locaux et régionaux."
      address="Zone Industriel Centrale"
      postalCode="81400"
      city="Carmaux"
      phone="05 63 76 41 56"
      email="contactgfe@groupefabre.com"
      services={services}
      coordinates={{ lat: 44.05362, lng: 2.14417 }}
      isMiniSite={true}
    />
  );
};

export default CarmausineRecuperation;